import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import userLogin from "../zustand/store/userStore";
import { verifyTokenAPI } from "../zustand/API";
import { Spin } from "antd";

export const ProtectedRoute = ({ element, allowedRoles }) => {
    const { authToken, user, logout } = userLogin();
    const [checking, setChecking] = useState(true);
    const [tokenValid, setTokenValid] = useState(false);

    useEffect(() => {
        const checkToken = async () => {
            try {
                const res = await verifyTokenAPI(authToken);
                console.log('res :', res)
                if (res.data?.valid) {
                    setTokenValid(true);
                } else {
                    logout();
                    setTokenValid(false);
                }
            } catch (err) {
                logout();
                setTokenValid(false);
            } finally {
                setChecking(false);
            }
        };
        if (authToken) {
            checkToken();
        } else {
            setChecking(false);
        }
    }, [authToken]);

    if (checking) {
        return (
            <div
                style={{
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Spin size="large" tip="Verifying token..." />
            </div>
        );
    }

    if (!authToken || !tokenValid) return <Navigate to="/home" />;
    if (!allowedRoles.includes(user?.role)) return <Navigate to="/" />;

    return element;
};

// export const redirectRoute = ({ auth, element, ...rest }) => {
//     return auth != null ? (
//         element
//     ) : (
//         <Navigate
//             to={{
//                 pathname: "/login",
//                 state: { from: rest.location },
//             }}
//         />
//     );
// };
